import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0e711f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fullscreen-modal-header" }
const _hoisted_2 = {
  key: 1,
  class: "h3"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close btn-link-grey__icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = { class: "visually-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepNav = _resolveComponent("StepNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.editMode)
      ? (_openBlock(), _createBlock(_component_StepNav, {
          key: 0,
          steps: _ctx.steps,
          step: _ctx.step,
          stepViews: _ctx.stepViews,
          onChangeStep: _cache[0] || (_cache[0] = () => {})
        }, null, 8, ["steps", "step", "stepViews"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.translate('shop.ticket.configuration.edit-your-configuration')), 1)),
    _createElementVNode("button", {
      class: "fullscreen-modal-header__close",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModal')))
    }, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate('shop.ticket.configuration.close')), 1)
    ])
  ]))
}